import apiClient from "Configuration/apiClient";
import API_CONFIG from "Configuration/apiConfig";

export const getScoreTypes = () => {
  return apiClient.get(API_CONFIG.ENDPOINTS.MASTERSHEETS.SCORETYPEDROPDOWN);
};

export const uploadStoreMaster = (file, month, year, scoretypeId) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("month", month);
  formData.append("year", year);
  formData.append("scoretypeId", scoretypeId);

  return apiClient.post(API_CONFIG.ENDPOINTS.MASTERSHEETS.UPLOAD, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    responseType: "text",
  });
};